import { Box, Typography } from '@mui/material';

const BandDashboard = () => {
  return (
    <Box maxWidth='lg'>
      <Typography variant='h5'>Band Administrator</Typography>
    </Box>
  );
};

export default BandDashboard;
